<div class="container-price-bordless">
  <div class="content">
    <h1 center="text-center">
      {{ membershipPricingMock?.priceBoxCommunityTranslation[0].title || "Plano" }}
      
      <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-free-rounded.svg" alt="" />
    </h1>
    <p>{{ membershipPricingMock?.priceBoxCommunityTranslation[0].subtitle || "Esse plano contém erros..." }}</p>
  </div>

  <div class="divisor"></div>

  <div class="content content-lists">
    <unh-quill-content-renderer [content]="membershipPricingMock?.priceBoxCommunityTranslation[0].description">
    </unh-quill-content-renderer>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
